import React from 'react';
import { ProgressbarContainer, ProgressbarValue, StyledProgressbar } from './Progressbar.styles';

export type Props = {
    selected: boolean;
    progress: number;
    className?: string;
};

const Progressbar = ({ selected, progress = 0, className }: Props): JSX.Element => {
    if (progress <= 0) {
        return null;
    }

    const correctProgress = Math.floor(Math.min(100, Math.max(0, progress)));
    const visiblePercent = correctProgress === 0 ? 1 : correctProgress;

    return (
        <ProgressbarContainer className={className}>
            <StyledProgressbar
                isSelected={selected}
                role="progressbar"
                aria-label="Förloppsindikator"
                aria-valuetext="Pågående program"
                aria-valuemin={0}
                aria-valuemax={100}
                aria-valuenow={correctProgress}
            >
                <ProgressbarValue isSelected={selected} progressPercent={visiblePercent} />
            </StyledProgressbar>
        </ProgressbarContainer>
    );
};

export default Progressbar;
